"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.APPLY_COUPON_CARD_STATIC = exports.APPLY_COUPON_CARD_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _CouponIcon = _interopRequireWildcard(require("./CouponIcon"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["title", "subtitle", "buttonText", "icon", "iconSize", "iconColors", "iconGap", "colors", "borderRadius", "fontFamily", "showButton", "showArrow", "arrowSize", "loading", "onApply", "sx"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const APPLY_COUPON_CARD_DEFAULTS = exports.APPLY_COUPON_CARD_DEFAULTS = {
  title: 'Apply Coupon “VisitAHC”',
  subtitle: 'Extra discount up to 20% ',
  buttonText: 'Apply',
  iconSize: 58,
  iconGap: 12,
  borderRadius: 16,
  fontFamily: 'Inter, sans-serif',
  colors: {
    gradientStart: '#f5f2ff',
    gradientEnd: '#ffffff',
    border: '#f2f2f3',
    title: '#000000',
    subtitle: '#1eb865',
    button: 'var(--primary-button, #714fff)',
    arrow: '#000000'
  },
  iconColors: _CouponIcon.COUPON_ICON_DEFAULT_COLORS
};
const APPLY_COUPON_CARD_STATIC = exports.APPLY_COUPON_CARD_STATIC = {
  title: 'Apply Coupon',
  subtitle: '',
  showButton: false,
  showArrow: true
};
const ArrowRightIcon = _ref => {
  let _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      display: 'block'
    },
    "aria-hidden": "true",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9 19L16 12L9 5",
      stroke: color,
      strokeWidth: "1.7",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const ApplyCouponCard = _ref2 => {
  let _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? APPLY_COUPON_CARD_DEFAULTS.title : _ref2$title,
    _ref2$subtitle = _ref2.subtitle,
    subtitle = _ref2$subtitle === void 0 ? APPLY_COUPON_CARD_DEFAULTS.subtitle : _ref2$subtitle,
    _ref2$buttonText = _ref2.buttonText,
    buttonText = _ref2$buttonText === void 0 ? APPLY_COUPON_CARD_DEFAULTS.buttonText : _ref2$buttonText,
    icon = _ref2.icon,
    _ref2$iconSize = _ref2.iconSize,
    iconSize = _ref2$iconSize === void 0 ? APPLY_COUPON_CARD_DEFAULTS.iconSize : _ref2$iconSize,
    iconColors = _ref2.iconColors,
    _ref2$iconGap = _ref2.iconGap,
    iconGap = _ref2$iconGap === void 0 ? APPLY_COUPON_CARD_DEFAULTS.iconGap : _ref2$iconGap,
    colorsProp = _ref2.colors,
    _ref2$borderRadius = _ref2.borderRadius,
    borderRadius = _ref2$borderRadius === void 0 ? APPLY_COUPON_CARD_DEFAULTS.borderRadius : _ref2$borderRadius,
    _ref2$fontFamily = _ref2.fontFamily,
    fontFamily = _ref2$fontFamily === void 0 ? APPLY_COUPON_CARD_DEFAULTS.fontFamily : _ref2$fontFamily,
    _ref2$showButton = _ref2.showButton,
    showButton = _ref2$showButton === void 0 ? true : _ref2$showButton,
    _ref2$showArrow = _ref2.showArrow,
    showArrow = _ref2$showArrow === void 0 ? false : _ref2$showArrow,
    _ref2$arrowSize = _ref2.arrowSize,
    arrowSize = _ref2$arrowSize === void 0 ? 20 : _ref2$arrowSize,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    onApply = _ref2.onApply,
    _ref2$sx = _ref2.sx,
    sx = _ref2$sx === void 0 ? {} : _ref2$sx,
    rest = _objectWithoutProperties(_ref2, _excluded);
  const colors = _objectSpread(_objectSpread({}, APPLY_COUPON_CARD_DEFAULTS.colors), colorsProp);
  const handleApply = loading ? undefined : onApply;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, _objectSpread(_objectSpread({
    onClick: handleApply,
    sx: _objectSpread({
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      pl: '10px',
      pr: '16px',
      py: '12px',
      borderRadius: "".concat(borderRadius, "px"),
      border: "1px solid ".concat(colors.border),
      background: "linear-gradient(to right, ".concat(colors.gradientStart, " 3%, ").concat(colors.gradientEnd, ")"),
      overflow: 'hidden',
      cursor: handleApply ? 'pointer' : 'default',
      fontFamily
    }, sx)
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        display: 'flex',
        flex: '1 0 0',
        minWidth: 0,
        alignItems: 'center',
        gap: "".concat(iconGap, "px")
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        sx: {
          flexShrink: 0,
          width: iconSize,
          height: iconSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        children: icon || /*#__PURE__*/(0, _jsxRuntime.jsx)(_CouponIcon.default, {
          size: iconSize,
          colors: iconColors
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          flex: '1 0 0',
          minWidth: 0,
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '4px'
        },
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: 1.4,
            letterSpacing: '0.25px',
            color: colors.title,
            m: 0
          },
          children: title
        }), subtitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 600,
            fontSize: '12px',
            lineHeight: 1.5,
            letterSpacing: '-0.2px',
            color: colors.subtitle,
            m: 0
          },
          children: subtitle
        })]
      })]
    }), showArrow && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: {
        flexShrink: 0,
        width: arrowSize,
        height: arrowSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ArrowRightIcon, {
        size: arrowSize,
        color: colors.arrow
      })
    }), showButton && buttonText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
      disableRipple: true,
      disabled: loading,
      onClick: e => {
        if (onApply && !loading) {
          e.stopPropagation();
          onApply(e);
        }
      },
      sx: {
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px'
      },
      children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
        size: 14,
        sx: {
          color: colors.button
        }
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        sx: {
          fontFamily,
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: 1.4,
          color: colors.button,
          whiteSpace: 'nowrap',
          m: 0
        },
        children: buttonText
      })
    })]
  }));
};
var _default = exports.default = ApplyCouponCard;